import Vue from 'vue';
import Vuex from 'vuex';
import menuRoutes from '@/js/menuRoutes';
import propertyMenuRoutes from '@/js/propertyMenuRoutes';
import govMenuRoutes from '@/js/govMenuRoutes';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dateDetail: {},
    forecast: [],
    nowWeather: {},
    time: '',
    activeIndex: '',
    isOptData: '',
    uploadUrl: '/file/ht_upload', // 文件上传路由
    apkAccept: '.apk,.ipa,.bin', // apk格式
    excelAccept: '.xls,.xlsx', // excel格式
    imgAccept: 'image/jpg,image/png,image/bmp,image/gif,image/jpeg', // 图片格式
    callFormat: '代码+位数，位数最多5位，B表示楼栋，U表示单元，R表示房间，如：B2U2R4，表示楼栋号2位、单元号2位、房间号4位，可以呼：01010508',
    modalDetailConfig: { // modal详情配置
      footer: null,
      closable: false,
      maskClosable: true,
      keyboard: true,
      destroyOnClose: true,
      centered: true,
      width: 800
    },
    modalConfig: {// modal配置
      maskClosable: false,
      keyboard: false,
      destroyOnClose: true,
      centered: true,
      width: 900
    },
    citys: ['北京市', '上海市', '天津市', '重庆市'],
    categoryAddApi: { // 分类新增api
      addProductCate: '/category/product/',
      addLocationCate: `/category/position/`,
      addApiCate: `/category/apis/`,
      addMsgtplCate: `/category/message_tpl/`,
      addDocCate: `/category/document/`
    },
    categoryAddModule: { // 分类新增下拉列表 module参数
      addProductCate: 'product',
      addLocationCate: `position`,
      addApiCate: `apis`,
      addMsgtplCate: `message_tpl`,
      addDocCate: `document`
    },
    categoryRoute: { // 分类跳转路由
      productCate: 'addProductCate',
      locationCate: 'addLocationCate',
      apiCate: 'addApiCate',
      msgtplCate: 'addMsgtplCate',
      docCate: 'addDocCate'
    },
    categoryListApi: { // 分类列表api
      productCate: '/category/product',
      locationCate: `/category/position`,
      apiCate: `/category/apis`,
      msgtplCate: `/category/message_tpl`,
      docCate: `/category/document`
    },
    feedBackStatusSelect: [
      { label: '已回复', value: 1 },
      { label: '未回复', value: 0 }
    ],
    sendStatusList: [
      { label: '已发送', value: 1 },
      { label: '未发送', value: 0 }
    ],
    pushStatusList: [
      { label: '已推送', value: 1 },
      { label: '未推送', value: 0 },
      { label: '被撤回', value: 3 }
    ],
    statusList: [
      { label: '正常', value: 1 },
      { label: '禁用', value: 0 }
    ],
    isSuccessList: [
      { label: '成功', value: 1 },
      { label: '失败', value: 0 }
    ],
    isExpireList: [
      { label: '未过期', value: 1 },
      { label: '已过期', value: 0 }
    ],
    booleanList: [
      { label: '是', value: 1 },
      { label: '否', value: 0 }
    ],
    isOnLineList: [
      { label: '在线', value: 1 },
      { label: '离线', value: 0 }
    ],
    isBandList: [
      { label: '绑定', value: 1 },
      { label: '未绑定', value: 0 }
    ],
    makeCardList: [
      { label: '普通', value: 0 },
      { label: '加密', value: 1 }
    ],
    sexList: [
      { label: '保密', value: 0 },
      { label: '男', value: 1 },
      { label: '女', value: 2 }
    ],
    userRange: [
      { label: '全部用户', value: 0 },
      { label: '指定城市', value: 1 },
      { label: '指定小区', value: 2 }
      // { label: '指定用户', value: 3 }
    ],
    platformList: [
      { label: 'Android', value: 1 },
      { label: 'iOS', value: 2 }
    ],
    base_itemLayout: {
      labelCol: { span: 8 },
      wrapperCol: { span: 9 }
    },
    long_itemLayout: {
      labelCol: {span: 5},
      wrapperCol: {span: 13}
    },
    modal_ItemLayout: {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 }
    },
    step_ItemLayout: {
      labelCol: { span: 5 },
      wrapperCol: { span: 19 }
    },
    advanced_colWidth: { md: 8, sm: 24 },
    advanced_col_12: { md: 12, sm: 24 },
    componentArr: [
      'propertyRole', 'company', 'propertyAccount', 'community',
      'building', 'unit', 'room', 'location', 'member',
      'householdAuthRecord', 'passport', 'smartDoor', 'keyApply',
      'keyList', 'cardRecord', 'openLog', 'locationCate',
      'productCate', 'product', 'device', 'systemMsg',
      'msgTemplate', 'push', 'document', 'advert',
      'feedBack', 'msgtplCate', 'docCate', 'role',
      'account', 'operationLog', 'appVersion', 'communityApp',
      'stewardApp', 'apiCate', 'api', 'projectAccount', 'govRole',
      'govAccount', 'orderManage', 'order', 'finance'
    ],
    noPageRoute: {
      path: '*',
      name: 'noPage',
      component: resolve => require(['../components/noPage'], resolve)
    },

    menuList: menuRoutes.menuList,
    routes: menuRoutes.routes,

    propertyMenu: propertyMenuRoutes.menuList,
    propertyRoutes: propertyMenuRoutes.routes,

    govMenu: govMenuRoutes.govMenu,
    govRoutes: govMenuRoutes.govRoutes
  },

  actions: {
    handleData ({ commit }, param) {
      commit('saveData', param);
    }
  },

  mutations: {
    /* 编辑或新增了数据（操作了数据） */
    setOptData (state, param) {
      state.isOptData = param;
    },
    setActiveIndex (state, param) {
      state.activeIndex = param;
    },

    saveData (state, params) {
      state.data = params;
    },
    setDateDetail (state, params) {
      state.dateDetail = params;
    },
    setForecast (state, params) {
      state.forecast = params;
    },
    setNowWeather (state, params) {
      state.nowWeather = params;
    },
    setTime (state, params) {
      state.time = params;
    }
  },

  getters: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js